module.exports = __webpack_public_path__ + "img/Estate-cars.100240a5.svg";